import { render, staticRenderFns } from "./Landowner.vue?vue&type=template&id=6fb6ce02"
import script from "./Landowner.vue?vue&type=script&lang=js"
export * from "./Landowner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports